/** O que a API de usuários devolve. */

export type Usuario = {
  id: number;
  nome: string;
  email: string;
  administrador: boolean;
  ativo: boolean;
  trocar_senha: boolean;
  foto_url: string | null;
  permissoes: string[];
  eu: boolean;
  /** Por que quem está logado não pode fazer cada ação; nulo quando pode. */
  impede: { editar: string | null; inativar: string | null; administrador: string | null; senha: string | null };
};

export type GrupoDePermissoes = {
  modulo: string;
  nome: string;
  permissoes: { slug: string; rotulo: string; pode_conceder: boolean }[];
};

export type RespostaUsuarios = { data: Usuario[]; permissoes: GrupoDePermissoes[]; sou_administrador: boolean };

/** "Folha: 3 de 4 · Cotação e compras: 1 de 9", ou "Administrador". */
export function resumoDoAcesso(usuario: Usuario, grupos: GrupoDePermissoes[]): string {
  if (usuario.administrador) {
    return 'Administrador';
  }

  const partes = grupos
    .map((grupo) => {
      const tem = grupo.permissoes.filter((permissao) => usuario.permissoes.includes(permissao.slug)).length;

      return tem === 0 ? null : `${grupo.nome}: ${tem} de ${grupo.permissoes.length}`;
    })
    .filter(Boolean);

  return partes.length === 0 ? 'Sem acesso' : partes.join(' · ');
}
